import { render, staticRenderFns } from "./OliveOilsEdit.vue?vue&type=template&id=611d4902"
import script from "./OliveOilsEdit.vue?vue&type=script&lang=js"
export * from "./OliveOilsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports